var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72727 3.09091C2.72727 2.89008 2.89008 2.72727 3.09091 2.72727H5.63636C5.83719 2.72727 6 2.56447 6 2.36364C6 2.16281 5.83719 2 5.63636 2H3.09091C2.48842 2 2 2.48842 2 3.09091V8.90909C2 9.51158 2.48842 10 3.09091 10H8.90909C9.51158 10 10 9.51158 10 8.90909V6.36364C10 6.16281 9.83719 6 9.63636 6C9.43553 6 9.27273 6.16281 9.27273 6.36364V8.90909C9.27273 9.10992 9.10992 9.27273 8.90909 9.27273H3.09091C2.89008 9.27273 2.72727 9.10992 2.72727 8.90909V3.09091Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45455 2C7.25372 2 7.09091 2.16281 7.09091 2.36364C7.09091 2.56447 7.25372 2.72727 7.45455 2.72727H8.75847L4.65196 6.83378C4.50995 6.97579 4.50995 7.20603 4.65196 7.34804C4.79397 7.49005 5.02421 7.49005 5.16622 7.34804L9.27273 3.24153V4.54545C9.27273 4.74629 9.43553 4.90909 9.63636 4.90909C9.83719 4.90909 10 4.74629 10 4.54545V2.36364C10 2.16281 9.83719 2 9.63636 2H7.45455Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.9d9f90f2effd4631e1773707365ce033.svg";
export { ForwardRef as ReactComponent };